/*
 * @Author: changcheng
 * @LastEditTime: 2023-11-15 15:43:12
 */
import { combineReducers } from "redux";
import userReducer from "./user";
import videoReducer from "./video";
import globalspinReducer from "./globalspin";
import dictionariesReducer from "./dictionaries";
import menuColumnIdReducer from "./menuColumnId";
import registerTypeReducer from "./register";
import advertisementReducer from "./advertisement";
import bannerReducer from "./banner";
const rootReducer = combineReducers({
  userInfo: userReducer,
  videoInfo: videoReducer,
  globalInfo: globalspinReducer,
  directionaries: dictionariesReducer,
  menuColumnId: menuColumnIdReducer,
  registerType: registerTypeReducer,
  advertisementData: advertisementReducer,
  bannerInfo: bannerReducer,
});
export default rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
